// src/components/layout/Sidebar.tsx
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';
import { NotificationBell } from '@/components/ui/NotificationBell';

export function Sidebar() {
  const { pathname } = useLocation();
  const { theme, toggleTheme } = useTheme();
  const isActive = (prefix: string) => pathname.startsWith(prefix);

  return (
    <aside className="app-sidebar app-sidebar-desktop">
      <nav style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        <IconButton href="/dashboard" label="Dashboard" icon="dashboard" active={isActive('/dashboard')} />
        <IconButton href="/archive" label="Archive" icon="inventory_2" active={isActive('/archive')} />
        <NotificationBell />
      </nav>

      <nav style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        <button
          type="button"
          onClick={toggleTheme}
          aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          className="sidebar-icon-btn"
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            border: 'none',
            background: 'transparent',
          }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 20 }} aria-hidden>
            {theme === 'dark' ? 'light_mode' : 'dark_mode'}
          </span>
        </button>
        <IconButton href="/settings" label="Settings" icon="settings" active={isActive('/settings')} />
        <IconButton href="/support" label="Support" icon="support_agent" active={isActive('/support')} />
        <IconButton href="/login" label="Logout" icon="logout" active={isActive('/login')} />
      </nav>
    </aside>
  );
}

export function BottomNav() {
  const { pathname } = useLocation();
  const isActive = (prefix: string) => pathname.startsWith(prefix);
  return (
    <nav className="app-bottom-nav">
      <IconButton href="/dashboard" label="Dashboard" icon="dashboard" active={isActive('/dashboard')} />
      <IconButton href="/archive" label="Archive" icon="inventory_2" active={isActive('/archive')} />
      <IconButton href="/settings" label="Settings" icon="settings" active={isActive('/settings')} />
      <IconButton href="/support" label="Support" icon="support_agent" active={isActive('/support')} />
    </nav>
  );
}

function IconButton({
  href,
  label,
  icon,
  active,
}: {
  href: string;
  label: string;
  icon: string;
  active: boolean;
}) {
  return (
    <Link
      to={href}
      aria-label={label}
      aria-current={active ? 'page' : undefined}
      title={label}
      className={`sidebar-icon-btn${active ? ' sidebar-icon-btn-active' : ''}`}
      style={{
        width: 40,
        height: 40,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <span className="material-symbols-outlined" style={{ fontSize: 20 }} aria-hidden>
        {icon}
      </span>
    </Link>
  );
}
